/**
 * Resizes an image data URL to a maximum dimension
 * @param {string} dataURL - The image data URL to resize
 * @param {boolean} resizeFlag - Whether to resize (default: true)
 * @param {number} maxWidth - Maximum width (default: 320)
 * @param {number} maxHeight - Maximum height (default: 240)
 * @returns {Promise<string>} - Promise that resolves with the resized data URL
 */
export const resizeDataURL = (dataURL, resizeFlag = true, MAX_W = 320, MAX_H = 240) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
            try {
                const w = img.width;
                const h = img.height;

                if (!resizeFlag || (w <= MAX_W && h <= MAX_H)) {
                    return resolve(dataURL);
                }

                const scale = Math.min(MAX_W / w, MAX_H / h);
                const newW = Math.floor(w * scale);
                const newH = Math.floor(h * scale);

                const resizeCanvas = document.createElement('canvas');
                resizeCanvas.width = newW;
                resizeCanvas.height = newH;

                const ctx = resizeCanvas.getContext('2d');
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = "high";

                ctx.drawImage(img, 0, 0, newW, newH);

                const resizedDataURL = resizeCanvas.toDataURL('image/jpeg');
                resolve(resizedDataURL);
            } catch (error) {
                console.error('Error in resizeDataURL:', error);
                reject(error);
            }
        };

        img.onerror = (error) => {
            console.error('Error loading image in resizeDataURL:', error);
            reject(error);
        };

        img.src = dataURL;
    });
};

// Export with the old name for backward compatibility if needed
export const resizeToDFromDataURL = resizeDataURL;
